import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  defaultMessageConstant= 'default message';
  private readonly messageSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly membershipSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly userRoleSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly bpgListSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly eventsViewDetailsSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly expenseEditDataSource = new BehaviorSubject(null);
  private readonly navigationBpgListSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly claimExpense = new BehaviorSubject(null);
  private readonly siteIdAndPathSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly eventDateSource = new BehaviorSubject('null');
  private readonly selectedEventDataSourceSource = new BehaviorSubject('null');
  private readonly messageApproveSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly budgetDateSource = new BehaviorSubject(null);
  private readonly selectedMyBpgsDataSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly selectedSiteIdSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly selectedSiteIdForSiteMenuSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly selectedNaacIdForNaacMenuSource = new BehaviorSubject(this.defaultMessageConstant);
  private readonly folderSectionSource = new BehaviorSubject('null');
  private readonly isEventPopupOpenedSource = new BehaviorSubject(null); 
  private readonly setBannerSource = new BehaviorSubject(null); 
  private readonly openSiteChangePopup = new BehaviorSubject(null);
  private readonly userDetails = new BehaviorSubject(null);
  savedMembershipForm = this.membershipSource.asObservable();
  savedData = this.messageSource.asObservable();
  userRoleData = this.userRoleSource.asObservable();
  bpgListData = this.bpgListSource.asObservable();
  selectedEventsDetails = this.eventsViewDetailsSource.asObservable();
  selectedBpgList = this.navigationBpgListSource.asObservable();
  expenseEditData = this.expenseEditDataSource.asObservable();
  claimExpenseData = this.claimExpense.asObservable();
  siteIdAndPath = this.siteIdAndPathSource.asObservable();
  eventDate = this.eventDateSource.asObservable();
  eventViewApprove = this.messageApproveSource.asObservable();
  claimExpenseApprove = this.messageApproveSource.asObservable();
  eventData = this.selectedEventDataSourceSource.asObservable();
  budgetData = this.budgetDateSource.asObservable();
  myBpgsData = this.selectedMyBpgsDataSource.asObservable();
  selectedSiteId = this.selectedSiteIdSource.asObservable();
  selectedSiteIdForSiteNavMenu = this.selectedSiteIdForSiteMenuSource.asObservable();
  selectedNaacIdForNaacMenu = this.selectedNaacIdForNaacMenuSource.asObservable();
  folderSection = this.folderSectionSource.asObservable();
  isEventPopupOpened = this.isEventPopupOpenedSource.asObservable();
  isBanner = this.setBannerSource.asObservable();
  siteEffectedPopup = this.openSiteChangePopup.asObservable();
  userData = this.userDetails.asObservable();
  constructor() { }

  saveData(message: any) {
    this.messageSource.next(message)
  }

  userRoleDetails(message: any) {
    this.userRoleSource.next(message)
  }
  bpgList(message: any) {
    this.bpgListSource.next(message);
  }
  showSavedMembershipForm(message: any) {
    this.membershipSource.next(message)
  }
  getSelectedEventDetails(message: any) {
    this.eventsViewDetailsSource.next(message);
  }

  selectedNavigationBpgs(message: any) {
    this.navigationBpgListSource.next(message);
  }
  selectedSiteIdAndPath(message: any) {
    this.siteIdAndPathSource.next(message);
  }
  // selectedSiteIdBpgIdAndPath(message: any) {
  //   this.siteIdBpgIdAndPathSource.next(message);
  // }
  setSelectedEventDate(message: any) {
    this.eventDateSource.next(message);
  }
  setselectedEventInfo(message: any) {
    this.selectedEventDataSourceSource.next(message);
  }
  // selectedSiteIdBpgIdAndPath(message:any){
  //   this.siteIdBpgIdAndPathSource.next(message);

  // }
  saveClaimData(data: any) {
    this.claimExpense.next(data);
  }

  setApproved(message: any) {
    this.messageApproveSource.next(message);
  }

  setEditExpenceData(message: any) {
    this.expenseEditDataSource.next(message);
  }

  saveBudget(message: any) {
    this.budgetDateSource.next(message);
  }
  setMyBpgSiteIdAndBpgId(message: any) {
    this.selectedMyBpgsDataSource.next(message);
  }
  setSiteId(message: any) {
    this.selectedSiteIdSource.next(message);
  }
  selectedSiteIdForSiteMenu(message: any) {
    this.selectedSiteIdForSiteMenuSource.next(message);

  }
  selectednaacIdForNaacMenu(message: any) {
    this.selectedNaacIdForNaacMenuSource.next(message);

  }
  folderSections(message: any) {
    this.folderSectionSource.next(message);

  }
  setEventPopupOpened(message: any)
  {
    this.isEventPopupOpenedSource.next(message);

  }
  setBanner(message: any)
    {
      this.setBannerSource.next(message)
    }
  
  siteAffectedPopup(message: any){
      this.openSiteChangePopup.next(message);
    }

    setUserDetails(message : any){
      this.userDetails.next(message);
    }

}

export class Bpgs {
  bpgId: number;
  name: string;
  desc: string;
}

export class Interests {
  areaOfImpactId: number;
  subcategory: string;
}

export class Skills {
  skillId: number;
  skillName: string;
  skillDesc: string;
}

export class Leadership {
  chair: boolean;
  viceChair: boolean;
  communicationsChair: boolean;
  financeChair: boolean;
}

export class Demographics {
  demograhicId: number;
  demographicsName: string;
}

export class Site {
  siteId: number;
  siteName: string;
  siteDesc: string;
}

export class MembershipFormData {
  virtualBpg: boolean;
  siteFormData: Site;
  bpgFormData: Bpgs[];
  interestFormData: Interests[];
  skillsFormData: Skills[];
  leadershipFormData: Leadership;
  //demographicsFormData:demographics[]; //demographic code commented
  otherSkillsFormData: string;

}

export class MembershipDetails {
  bpgIds: any[] = [];
  skillIds: any[] = [];
  areaOfImpactIds: any[] = [];
  demographicIds: any[] = [];
  otherSkills: string;
  leadershipDetails: Leadership;

}

export class MembershipData {
  bpgIds: any[] = [];
  skillIds: any[] = [];
  areaOfImpactIds: any[] = [];
  demographicIds: any[] = [];
  otherSkills: string;
  leadershipDetails: Leadership;
}


export class LandingDTOModel {
  filter: FilterModel;
  moduleId: number;
  page = 0;
  presentRole = '-';
  searchTerm = '';
  size = 0;
  sortDirection = 'ASC';
  sortProperty = '-';
  uid = '-';
  expenseId?: number;
  leadAdminApprovedBy?: number;
  leadAdminApprovalComment?: string;
  superAdminApprovedBy?: number;
  superAdminApprovalComment?: string;
  expenseStatus?: string;
}

export class FilterModel {
  userId?: string;
  siteId?: string;
  fromDate?: string;
  toDate?: string;
  bpgId?: string;
  chapterId?: string;
  adminId?: string;
  eventId?: string;
  hoshinId?: string;
}

export class Budget {
  budgetId?: number;
  chapterId?: number;
  fiscalYear?: string;
  affinityGoals?: string = "";
  chapterGoals?: string = "";
  chapterName?: string = "";
  siteName?: string = "";
  budgetStatus?: string = "";
  budgetAllocatedDate?: Date = null;
  budgetAllocatedBy?: string = "";
  comment?: string = "";
  budgetSource?: string = "";
  requestedBudgetAmount?: number;
  approvedBudgetAmount?: number;
  budgetRequestedBy?: number;
  budgetRequestedDate?: Date = null;
}
export class Amount{
  requestedAmount? : number;
  approvedAmount? : number;
  
  }
export class Hoshin {
  hoshinId?: number;
  chapterId?: number;
  fiscalYear?: any;
  bpgInitiative?: string = "";
  businessDrivers?: string = "";
  actionPlan?: string = "";
  kpi?: string = "";
  estimatedTiming?: string = "";
  proposedBudget?: number;
  leadApprovedBudget?: number;
  superAdminApprovedBudget?: number;
  midYearResults?: string = "";
  yearEndResults?: string = "";
  challenges?: string = "";
  hoshinPlanBy?: number;
  supportingDoc1?: string = "";
  isLeadApproved?: boolean;
  leadAdminApprovedBy?: number;
  leadAdminApprovalComment?: string = "";
  isSuperAdminApproved?: boolean;
  superAdminApprovedBy?: number;
  superAdminApprovalComment?: string = "";
  hoshinSubmitDate?: Date = null;
  leadAdminApprovedDate?: Date = null;
  superAdminApprovedDate?: Date = null;
  name?: string = "";
  budgetType?: string = "";
  createdBy?: string = "";
  modifiedBy?: string = "";
  isActive?: boolean;
  actionPlaceholder?: string;
  kpiPlaceholder?: string;
  status?: string = "";
  frequency?: string = "";
  leadId1?: number;
  leadId2?: number;
  lead1Name?: string = "";
  lead2Name?: string = "";
  baseHoshinExists?: string = "";
  additionalFunding?: string = "";
  additionalFundingSource?: string = "";
  evaluation?: string = "";
}

export class BudgetHoshin {
  budgetMasterDTO: Budget;
  hoshinMasterDTOList: Hoshin[];
  deleteHoshinIds: Array<number>;
  hoshinSave?: boolean;
}

/* Survey Response */
export class Employee {
  userId: any;
}
export class SurveyQuestion {
  surveyQuestionId: any;
}
export class SurveyAnswer {
  answerId: any;
}
export class TakeSurvey {
  comments = "";
  modifiedBy?: string = "";
  createdBy?: string = "";
  employee: Employee;
  surveyAnswer: SurveyAnswer;
  surveyQuestion: SurveyQuestion;
  surveyResponseId: any;
  surveyId: any;
  surveyTakenUserName = "";
}

export class SurveyMaster {
  surveyId: number;
  eventId: number;
  surveryDesc?: string = "";
  surveyLaunchAdmin: number;
  startDate?: Date = new Date();
  endDate?: Date = new Date();
}

export class SitePrimaryContactDTO {
  createdBy = "";
  createdDateTime: Date = null;
  isActive: boolean;
  siteId: number;
  sitePrimaryContactId: number = null;
  userId: number;
}

export class SuveyTakenByUserDTO {
  surveyId: number;
  userId: number;
}

/*Pagination DTO */
export class LandingPaginationDTO {
  filter: {};
  moduleId = 0;
  page = 0;
  presentRole = '';
  searchTerm = '';
  size = 0;
  sortDirection = '';
  sortProperty = '';
  uid = '';
}

